import { api } from './api';

const base = '/smart-pos';

/**
 * Smart POS reaches only its dedicated server route.  The server derives
 * origin=smart_pos and passes the validated request into the atomic document
 * writer; the browser never supplies an account counterpart, actor, or origin.
 */
export const smartPos = {
  options: () => api.get(`${base}/options`),
  documents: params => api.get(`${base}/documents`, { params }),
  create: payload => api.post(`${base}/documents`, payload),
  settle: (id, payload) => api.post(`${base}/documents/${encodeURIComponent(id)}/settlements`, payload),
  settlePos: payload => api.post(`${base}/settlements`, payload),
};
